import {Pipe, PipeTransform} from '@angular/core'

@Pipe({
  name: 'bgoMax',
  pure: true,
})
export class MaxPipe implements PipeTransform {
  transform(n: number[]): number {
    return Math.max(...n)
  }
}
